import React, { useEffect, useState } from "react";
import { Chip } from "@mui/material";

const ContactSensor1Widget = ({ widget, onValueUpdate }) => {
  const [value, setValue] = useState(null);
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    if (!widget) return;
    setWidgetData(widget);

    if (widget.items?.$w1) {
      const currentValue = widget.items.$w1.value;
      setValue(
        currentValue === "" || currentValue === null ? "close" : currentValue
      );
    }
  }, [widget]);

  const getStatusText = () => {
    if (!value) return "close";
    return value;
  };

  const getChipColor = () => {
    switch (value) {
      case "open":
        return "secondary";
      case "close":
        return "default";
      default:
        return "default";
    }
  };

  return (
    <Chip
      label={getStatusText()}
      color={getChipColor()}
      variant="contained"
      sx={{
        width: "100%",
        fontWeight: 500,
        fontSize: "0.875rem",
        textTransform: "capitalize",
      }}
    />
  );
};

export default ContactSensor1Widget;
